import React from "react";
import PropTypes from "prop-types";

import GameLoader from "components/Loaders/Game";
import Content from "./GameDetails";
import ErrorBoundary from "components/ErrorBoundary";
import GameError from "./Error";
import PayStatus from "../../../features/PayStatus/PayStatus";

const PageGameDetails = ({ privateCode, gameId, history }) => {
    return (
        <>
            <ErrorBoundary>
                <PayStatus privateCode={privateCode} history={history}/>
                <GameLoader
                    id={gameId}
                    privateCode={privateCode}
                    renderErrorMessage={() => <GameError />}
                >
                    <Content gameId={gameId} />
                </GameLoader>
            </ErrorBoundary>
        </>
    );
};

PageGameDetails.propTypes = {
    CanGetGame: PropTypes.bool,
    gameId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    privateCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    history: PropTypes.object,
};

export default PageGameDetails;
